/* eslint-disable no-dupe-class-members */
import { Injectable } from '@angular/core';
import { ApiClient } from '../api.client';
import { WorkshopJob } from '../../models/workshop-job';
import { WorkshopJobListItem } from '../../models/workshop-job-list-item';
import { WorkshopJobHistoryItem } from '../../models/workshop-job-history-item';
import { Sort } from '@angular/material/sort';
import { AssignUserPersistenceService } from '../general/assigned-to/assign-to-user.service';
import { Observable } from 'rxjs';

@Injectable()
export class WorkshopJobService {
  private resourceEndpoint = 'workshop-jobs';

  constructor(private http: ApiClient) {}

  public getAll() {
    return this.http.get<WorkshopJob<any>[]>(this.resourceEndpoint);
  }

  public getForRepairDocket(id: number) {
    return this.http.get<WorkshopJob<any>[]>(
      `repair-dockets/${id}/${this.resourceEndpoint}`
    );
  }

  public addWorkshopJob(job: Partial<WorkshopJob<any>>) {
    return this.http.post<WorkshopJob<any>>(`${this.resourceEndpoint}`, job);
  }

  delete(id: number) {
    return this.http.delete(`${this.resourceEndpoint}/${id}`);
  }

  update(id: number, workshopJob: Partial<WorkshopJob<any>>) {
    return this.http.put<WorkshopJob<any>>(
      `${this.resourceEndpoint}/${id}`,
      workshopJob
    );
  }

  getPendingJobs() {
    return this.http.get<WorkshopJobListItem[]>(
      `${this.resourceEndpoint}/pending`
    );
  }

  getJob(id: number) {
    return this.http.get<WorkshopJob<any>>(`${this.resourceEndpoint}/${id}`);
  }

  getHistory(repairableType: string, repairableId: number) {
    return this.http.get<WorkshopJobHistoryItem[]>(
      `${this.resourceEndpoint}/history?repairable_type=${repairableType}&repairable_id=${repairableId}`
    );
  }

  getJobListItems(
    search: string,
    status: string[],
    customerType: string,
    page: number,
    pageSize: number,
    sort: Sort | null,
    excelExport: false
  ): Observable<{
    data: WorkshopJobListItem[];
    count: number;
    statusCounts: { [key: string]: number };
  }>;
  getJobListItems(
    search: string,
    status: string[],
    customerType: string,
    page: number,
    pageSize: number,
    sort: Sort | null,
    excelExport: true
  ): Observable<string>;
  getJobListItems(
    search: string,
    status: string[],
    customerType: string,
    page: number,
    pageSize: number,
    sort: Sort | null,
    excelExport = false
  ): any {
    let qs = `?search=${search}&externalInternal=${customerType}&page=${page}&pageSize=${pageSize}`;
    if (status.length) {
      qs += status.map((s) => `&status[]=${s}`).join('');
    }
    if (sort) {
      qs += `&sort=${sort.active}&direction=${sort.direction}`;
    }

    if (excelExport) {
      return this.getExcelExport(`${this.resourceEndpoint}/pending${qs}`);
    }
    return this.http.get<{
      data: WorkshopJobListItem[];
      count: number;
      statusCounts: { [key: string]: number };
    }>(`${this.resourceEndpoint}/pending${qs}`);
  }

  private getExcelExport(url) {
    return this.http.get(url, {
      responseType: 'blob',
      headers: {
        Accept:
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      }
    });
  }

  print(id: number) {
    return this.http.getResponse(`${this.resourceEndpoint}/${id}/print`);
  }
}
